import React from "react";
import { cn } from "../../lib/utils";

const buttonVariants = {
  default: "bg-gold hover:bg-cream text-white hover:text-dark-navy",
  outline: "bg-transparent border border-gold text-gold hover:bg-cream/10",
  secondary: "bg-cream hover:bg-gold text-dark-navy hover:text-white",
  ghost: "bg-transparent hover:bg-cream/20 text-dark-navy",
  link: "bg-transparent underline-offset-4 hover:underline text-gold hover:text-cream",
};

const Button = ({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}) => {
  const Comp = asChild ? React.cloneElement(props.children, { ...props, className: "" }) : "button";
  
  return React.createElement(
    asChild ? Comp.type : Comp,
    {
      className: cn(
        "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50",
        buttonVariants[variant],
        {
          "px-4 py-2 text-sm": size === "default",
          "h-8 px-2 text-xs": size === "sm",
          "h-10 px-8": size === "lg",
        },
        className
      ),
      ...(asChild ? { ...Comp.props } : props),
    },
    !asChild && props.children
  );
};

export { Button, buttonVariants };
